import { render, staticRenderFns } from "./mdModalEditProblem.vue?vue&type=template&id=52fdf363&"
import script from "./mdModalEditProblem.vue?vue&type=script&lang=js&"
export * from "./mdModalEditProblem.vue?vue&type=script&lang=js&"
import style0 from "./mdModalEditProblem.vue?vue&type=style&index=0&lang=css&"
import style1 from "./mdModalEditProblem.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports